export default "__VITE_ASSET__COu$JpPR__"